import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2401b66a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-tab" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      sticky: "",
      onClickTab: _ctx.onClickTab,
      "title-active-color": "#6A4DB9",
      color: "#6A4DB9"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (name) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            title: name,
            key: name
          }, null, 8, ["title"]))
        }), 128)),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    }, 8, ["active", "onClickTab"])
  ]))
}